import * as React from "react";
import { Layout } from "../components";

const megnyito = () => {
  return (
    <Layout>
      <h1>A Soproni Fotóművészeti Kör nevében tisztelettel köszöntöm a kedves kiállítás Látogatót!</h1>
      <p>Sajnos a vírushelyzet megakadályozott minket abban, hogy a szokásos decemberi kiállításunkat a Torony-Galériában rendezzük meg. Lemondani az eseményről mégsem szerettünk volna, ezért itt online formában lehet megtekinteni a képeket.</p>
      <p>Mostani kiállításunkhoz ihletet elmúlt korok művészei és irányzatai adtak, és ezáltal a tagok stílus- és formajegyeinek különbözősége még szembe tűnőbbé vált. Így került a képbe Picasso, Magritte, Monet, Vasarely, Rembrandt, Mondrian, Degas, Van Gogh, Murillo, a kubizmus, az impresszionizmus, az expresszionizmus, a geometrikus absztrakt, a szürrealizmus, a szimbolizmus, és még sorolhatnám.</p>
      <p>Kellemes kikapcsolódást és felfedezéssel teli élményeket kívánok..</p>
      <p>Ujvári Gábor<br/>SFK elnök</p>
    </Layout>
  );
};

export default megnyito;
